var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import eventLib from '@/common/utils/document-event';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { systemMessageUnreadCountAPI } from '@/api/common';
import Messages from '@/wkcrmViews/layout/components/Messages.vue';
import Examine from './Examine/index.vue';
import { getUserConfig } from '@/common/api/common';
var CrmMenu = /** @class */ (function (_super) {
    __extends(CrmMenu, _super);
    function CrmMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sysMessageShow = false;
        _this.examineShow = false;
        _this.intervalId = null;
        _this.showMessageButton = false;
        _this.unreadNums = {
            allCount: 0,
            announceCount: 0,
            crmCount: 0,
            examineCount: 0,
            eventCount: 0,
            logCount: 0,
            taskCount: 0
        };
        return _this;
    }
    Object.defineProperty(CrmMenu.prototype, "companyId", {
        get: function () {
            return this.$store.state.common.user.companyId || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrmMenu.prototype, "messageNum", {
        get: function () {
            return this.$store.getters['messageNum'];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrmMenu.prototype, "messageCount", {
        get: function () {
            return (this.messageNum.totalNum || 0) + (this.unreadNums.allCount || 0);
        },
        enumerable: false,
        configurable: true
    });
    CrmMenu.prototype.companyChange = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var showMessageButton;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!id) return [3 /*break*/, 2];
                        return [4 /*yield*/, getUserConfig()];
                    case 1:
                        showMessageButton = (_a.sent()).showMessageButton;
                        if (showMessageButton) {
                            this.showMessageButton = true;
                            this.getSystemUnreadNum('visible');
                        }
                        else {
                            this.showMessageButton = false;
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CrmMenu.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var showMessageButton;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getUserConfig()];
                    case 1:
                        showMessageButton = (_a.sent()).showMessageButton;
                        if (showMessageButton) {
                            this.showMessageButton = true;
                            this.getSystemUnreadNum('visible');
                        }
                        else {
                            this.showMessageButton = false;
                        }
                        // 消息数
                        this.$bus.on('document-visibility', function (state) { return __awaiter(_this, void 0, void 0, function () {
                            var showMessageButton;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, getUserConfig()];
                                    case 1:
                                        showMessageButton = (_a.sent()).showMessageButton;
                                        if (showMessageButton) {
                                            this.showMessageButton = true;
                                            this.getSystemUnreadNum(state);
                                        }
                                        else {
                                            this.showMessageButton = false;
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        // 全局监听
                        // 打开
                        eventLib.on('UPDATE_EXAMINE', this.getSystemUnreadNum);
                        this.$once('hook:beforeDestroy', function () {
                            eventLib.remove('UPDATE_EXAMINE', _this.getSystemUnreadNum);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CrmMenu.prototype.closeExamineHandle = function () {
        this.examineShow = false;
    };
    CrmMenu.prototype.closeMessageHandle = function () {
        this.sysMessageShow = false;
    };
    /**
     * 查看消息详情
     */
    CrmMenu.prototype.checkMessageDetail = function () {
        this.sysMessageShow = true;
    };
    /**
     * 获取系统未读消息数
     */
    CrmMenu.prototype.getSystemUnreadNum = function (state) {
        var _this = this;
        if (state === void 0) { state = 'visible'; }
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        if (state === 'visible') {
            this.sendSystemUnreadNum();
            this.intervalId = setInterval(function () {
                _this.sendSystemUnreadNum();
            }, 600000);
        }
    };
    CrmMenu.prototype.sendSystemUnreadNum = function () {
        var _this = this;
        systemMessageUnreadCountAPI({})
            .then(function (res) {
            _this.unreadNums = __assign({}, res.data);
        })
            .catch(function () {
            if (_this.intervalId) {
                clearInterval(_this.intervalId);
                _this.intervalId = null;
            }
        });
    };
    __decorate([
        Watch('companyId')
    ], CrmMenu.prototype, "companyChange", null);
    CrmMenu = __decorate([
        Component({
            components: {
                Messages: Messages,
                Examine: Examine
            },
        })
    ], CrmMenu);
    return CrmMenu;
}(Vue));
export default CrmMenu;
